var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section2"},[_vm._v("影片區塊")])}
var staticRenderFns = []

export { render, staticRenderFns }